import { jsx as _jsx } from "react/jsx-runtime";
import { Pencil, Resolve, Trash } from "@air/next-icons";
export const getDiscussionCommentMenuOptions = (param)=>{
    let { onDelete, onEdit, onResolve } = param;
    const options = [];
    if (onResolve) {
        options.push({
            id: "resolve",
            label: "Resolve",
            onSelect: onResolve,
            prefix: /*#__PURE__*/ _jsx(Resolve, {
                className: "size-4"
            }),
            type: "item"
        });
    }
    if (onEdit) {
        options.push({
            id: "edit",
            label: "Edit",
            onSelect: onEdit,
            prefix: /*#__PURE__*/ _jsx(Pencil, {
                className: "size-4"
            }),
            type: "item"
        });
    }
    if (onDelete) {
        options.push({
            id: "delete",
            label: "Delete comment",
            onSelect: onDelete,
            prefix: /*#__PURE__*/ _jsx(Trash, {
                className: "size-4"
            }),
            type: "item"
        });
    }
    return options;
};
